<template>
    <div class="page-content" style="min-height: 100vh">
        <div class="content-wrapper">
            <div class="content d-flex justify-content-center align-items-center">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GuestLayout",
}
</script>
